import superagent from 'superagent'

export const huntplannerMorefilters = payload => ({
    type: 'HUNT_PLANNER_MORE_FILTER',
    payload: payload
})

export const expandMorefilterMenu = (payload) => ({
    type: 'EXPAND_HUNT_PLANNER_MORE_FILTER',
    payload: payload
})

export const closeMorefilterMenu = () => ({
    type: 'CLOSE_HUNT_PLANNER_MORE_FILTER'
})